import type { Field, FieldValue } from 'models/field';
import type { I18n } from 'utils/translations/translations';

const RELATIONSHIP_FIELD_ID = 'relationship';

const translateFieldValues = (values: FieldValue, i18n: I18n): FieldValue => {
  if (!Array.isArray(values)) {
    return values;
  }

  return values.map(value => {
    if (value === null || typeof value !== 'object' || !('label' in value)) {
      return value;
    }
    return { ...value, label: i18n.t(value.label as string) };
  }) as unknown as FieldValue;
};

export const translateRelationshipField = (
  fields: Field[],
  i18n: I18n,
): Field[] => {
  return fields.map(field => {
    if (field.id !== RELATIONSHIP_FIELD_ID) {
      return field;
    }

    return {
      ...field,
      value: field.value
        ? translateFieldValues(field.value as FieldValue, i18n)
        : field.value,
      viewOptions: field.viewOptions
        ? {
            ...field.viewOptions,
            sectionIdentifier: field.viewOptions.sectionIdentifier,
            sectionDescription: field.viewOptions.sectionDescription,
            label: field.viewOptions.label
              ? i18n.t(field.viewOptions.label as string)
              : '',
            sectionName: field.viewOptions.sectionName
              ? i18n.t(field.viewOptions.sectionName as string)
              : '',
            help: field.viewOptions.help
              ? i18n.t(field.viewOptions.help as string)
              : field.viewOptions.help,
            hint: field.viewOptions.hint
              ? i18n.t(field.viewOptions.hint as string)
              : field.viewOptions.hint,
            placeholder: field.viewOptions.placeholder
              ? i18n.t(field.viewOptions.placeholder as string)
              : field.viewOptions.placeholder,
          }
        : field.viewOptions,
    } as Field;
  });
};
